import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { useLang } from "@/lib/i18n";
import { Lock } from "lucide-react";

export default function Login() {
  const { t } = useLang();
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`${t.login.welcome}, ${u.name}`);
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || t.login.error);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--mel-surface)] grain-bg p-6">
      <form onSubmit={submit} className="w-full max-w-md bg-[var(--mel-bg)] rounded-md border border-[var(--mel-border)] p-10" data-testid="login-form">
        <div className="w-12 h-12 rounded-full flex items-center justify-center mb-6" style={{ background: 'var(--mel-primary)' }}>
          <Lock size={20} className="text-white" />
        </div>
        <h1 className="font-serif text-3xl tracking-tight mb-2">{t.login.title}</h1>
        <p className="text-sm text-[var(--mel-muted)] mb-8">{t.login.subtitle}</p>

        <label className="text-xs eyebrow">{t.login.email}</label>
        <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full mt-1 mb-4 border border-[var(--mel-border)] rounded-md px-3 py-2.5 text-sm bg-white" data-testid="login-email" />
        <label className="text-xs eyebrow">{t.login.password}</label>
        <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full mt-1 mb-6 border border-[var(--mel-border)] rounded-md px-3 py-2.5 text-sm bg-white" data-testid="login-password" />

        <button disabled={busy} className="mel-btn-primary w-full justify-center" data-testid="login-submit">
          {busy ? t.login.submitting : t.login.submit}
        </button>
      </form>
    </div>
  );
}
